import { useFeatureFlag } from '@order/LaunchDarkly';

export const useDeliveryInFlightFeatureFlag = () => {
  return useFeatureFlag('XP-3203-short-delivery-in-flight-modal-enabled');
};
